export default [
  {
    path: '/conversion',
    name: 'conversion',
    component: resolve => require(['@/pages/activity/conversion'], resolve)
  },
  {
    path: '/conversion/logistics',
    name: 'logistics',
    component: resolve =>
      require(['@/pages/activity/conversion/components/Logistics.vue'], resolve)
  }
]
